import { mapValues, noop, omit } from 'lodash-es';
import { createContext, useState } from 'react';

export const LocationMode = {
  origin: 'origin',
  destination: 'destination',
};

const LocationModeInfo = {
  [LocationMode.origin]: {
    labelId: 'job.origin',
    getJobLocation: job => job.origin,
  },
  [LocationMode.destination]: {
    labelId: 'job.destination',
    getJobLocation: job => job.destination,
  },
};
export function getLocationModeInfo(locationMode) {
  return LocationModeInfo[locationMode] || LocationModeInfo.destination;
}

const EMPTY_CURSOR = {
  rows: [],
  hasNext: false,
  loadNext: noop,
  totalRows: 0,
  error: undefined,
  loading: false,
  loadingPage1: false,
};

export const MonitorContext = createContext({
  activeJob: undefined,
  setActiveJob: noop,
  locationMode: LocationMode.destination,
  setLocationMode: noop,
  variables: {},
  data: {
    active: EMPTY_CURSOR,
    saved: EMPTY_CURSOR,
    live: EMPTY_CURSOR,
    delivered: EMPTY_CURSOR,
    all: EMPTY_CURSOR,
  },
  activeSection: 'live',
  setActiveSection: noop,
  baseCounts: {},
});

export function MonitorProvider({
  data,
  baseCounts,
  variables,
  initialSection = 'live',
  activeSection: controlledActiveSection,
  setActiveSection: controlledSetActiveSection,
  children,
}) {
  const [activeJob, setActiveJob] = useState();
  const [internalActiveSection, setInternalActiveSection] =
    useState(initialSection);
  const [locationMode, setLocationMode] = useState(LocationMode.destination);

  const activeSection =
    controlledActiveSection !== undefined
      ? controlledActiveSection
      : internalActiveSection;
  const setActiveSection =
    controlledSetActiveSection || setInternalActiveSection;

  const value = {
    data: mapValues(data, obj => (obj ? omit(obj, ['refresh']) : obj)),
    variables,
    activeJob,
    setActiveJob,
    locationMode,
    setLocationMode,
    activeSection,
    setActiveSection,
    baseCounts: baseCounts || data,
  };

  return (
    <MonitorContext.Provider value={value}>{children}</MonitorContext.Provider>
  );
}
